import { Component, OnInit, ViewChild, Optional, ViewContainerRef } from '@angular/core';
import { CoinEventsService } from '../../_services/coinevents.service';
import { Observable } from 'rxjs/Observable';
import { AsyncPipe } from '@angular/common';
import { DialogService } from 'ng2-bootstrap-modal';
import { AddCoinEventsComponent } from './add-coin-events/add-coin-events.component';
import { EditCoinEventsComponent } from './edit-coin-events/edit-coin-events.component';
import { ConfirmComponent } from '../../_common/confirm/confirm.component';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'app-coinevents',
    templateUrl: './coinevents.component.html',
    styleUrls: ['./coinevents.component.css']
})
export class CoinEventsComponent implements OnInit {

    listCoins: Observable<any[]>;
    dataListCoins: any[] = [];
    objectListCoins: any = {};
    coinName: string;
    delayTimer: any;
    dtTrigger: Subject<any> = new Subject();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};

    constructor(
        private coinEventsService: CoinEventsService, 
        private dialogService: DialogService
    ) {
    }

    ngOnInit() {
        this.registerTable();
        this.listCoins = this.coinEventsService.getListCoin();        
        this.listCoins.subscribe(data => {
            this.dataListCoins = data;
            data.forEach(element => {
                this.objectListCoins[element.id] = element.name;
            });
            this.dtTrigger.next();
        });
    }

    registerTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';

                //assign parameters object
                self.parameters = parameters;
                //assign callback object
                self.callback = callback;

                //get param to callback
                self.coinEventsService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "コインイベント名",
                    data: "coin_name",
                    name: "coin_name",
                    className: "all text-justify"
                },
                {
                    title: "",
                    data: "btn_is_active",
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;

                //bind btn active
                $('.btn-active', row).bind('click', () => {
                    self.openActive(data);
                });

                //bind btn edit
                $('.btn-edit', row).bind('click', () => {
                    self.openEdit(data);
                });

                //bind btn delete
                $('.btn-delete', row).bind('click', () => {
                    self.confirmDelete(data);
                });
                return row;
            }
        };
    }

    //value change when search
    valuechange(newValue) {
        this.coinName = newValue;
        this.doSearch();
    }

    //do search
    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    //active status coin
    openActive(data) {
        this.coinEventsService.active(data).subscribe(data => {
            this.loadCurrentPage();
        }, error => {

        });
    }

    //edit info coin
    openEdit(data) {
        this.dialogService.addDialog(EditCoinEventsComponent, {
            coinId: data.id
        }).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    //confirm delete coin
    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, { 
            title: '確認', 
            message: '削除しますが、よろしいでしょうか？' 
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                //use service to delete coin
                this.coinEventsService.delete(data.id).subscribe(data => {
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }

    //add coin
    openModalAddCoin() {
        let self = this;
        this.dialogService.addDialog(
            AddCoinEventsComponent, 
            { listCoins: this.dataListCoins }
        ).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    //rerender data table
    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    //load current page after change action
    loadCurrentPage() {
        
        //load listCoins from service
        this.listCoins = this.coinEventsService.getListCoin();        
        this.listCoins.subscribe(data => {
            this.dataListCoins = data;
            data.forEach(element => {
                this.objectListCoins[element.id] = element.name;
            });
        });

        //get parameters and retrive result of current page 
        this.coinEventsService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coinevents/coinevents.component.ts